import React, { useState, useEffect } from "react";
import { IconButton } from "src/components/buttons";
import { Icon } from "src/components/icons/Icon";
import { FileText } from "lucide-react";
import { Colours } from "../../../../branding/ImpiricaBrand";
import { toast } from "react-toastify";

interface IProps {
	fetchReportData(): Promise<boolean | undefined>;
}

const GenerateExceleRATEPdf: React.FunctionComponent<IProps> = (props) => {
	const { fetchReportData } = props;
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		const generateExceleRATEPdf = async () => {
			try {
				const reportData = await fetchReportData();

				if (reportData == null || reportData == undefined)
					throw "An error occurred fetching report data";
			} catch (e) {
				console.error(e);
				toast.error("An error occurred generating the pdf");
			}
		};
		if (loading) {
			generateExceleRATEPdf();
			setLoading(false);
		}
	}, [loading]);

	return (
		<IconButton
			className="p-1 m-0.5 btn-link"
			title="View report"
			disabled={loading}
			onClick={() => setLoading(true)}
		>
			<Icon
				color={loading ? "gray" : Colours.secondary}
				icon={FileText}
			/>
		</IconButton>
	);
};

export default GenerateExceleRATEPdf;
